import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {UnpaidWorkGrid} from "./grid";
import {getUnpaidWorks} from "../../services/unpaid_work/unpaid_work";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {UnpaidWorkContext} from "../../context/unpaid_work";
import {PaginateContext} from "../../context/paginate";
import {UnpaidWorkForm} from "./form";


export function UnpaidWorkManagement() {

  const [unpaidWorks, setUnpaidWorks] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getUnpaidWorks(paginate);
    if (result.status === 200) {
      const {cancelPaymentList, total_count} = result.data;
      setUnpaidWorks(cancelPaymentList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    // const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [gridCurrentPage, gridRowCount, sortBy, sortType, lastDataRefresh]);

  return (
    <UnpaidWorkContext.Provider value={{
      unpaidWorks: unpaidWorks,
      setUnpaidWorks: setUnpaidWorks,
      unpaidWork: gridSelectedRow,
      setUnpaidWork: setGridSelectedRow,
      open: modalOpen,
      setOpen: setModalOpen,
      setLastDataRefresh: setLastDataRefresh,
    }}>
      <PaginateContext.Provider value={{
        setSortBy: setSortBy,
        sortType: sortType,
        setSortType: setSortType,
        active: gridCurrentPage,
        setActive: setGridCurrentPage,
        totalRows: gridTotalRowCount,
        rowsCount: gridRowCount,
        setRowsCount: setGridRowCount,
        from: from,
        to: to,
      }}>
        <div className="">

          <UnpaidWorkForm/>

          <Card className="pt-8">
            <CardHeader floated={true} shadow={false} className="rounded-none">
              <div className="mb-8 flex items-center justify-between gap-8">
                <Typography variant="h5" color="blue-gray">مدیریت تسویه و لغو پرداخت</Typography>
              </div>
            </CardHeader>

            <CardBody className="overflow-x-auto w-full">
              <UnpaidWorkGrid/>
            </CardBody>

            <CardFooterPaginator/>

          </Card>
        </div>
      </PaginateContext.Provider>
    </UnpaidWorkContext.Provider>
  );
}